const messageSeverity = {
    unknown: 0,
    severeFloodWarning: 1,
    floodWarning: 2,
    floodAlert: 3,
    noLongerInForce: 4
}

export default messageSeverity;
